<template>
  <div>

    <h1>{{profileData.rights.displayName[actualLanguage]}}</h1>



                   <!-- Full Table -->
                    <div class="block">
                        <div class="block-header">
                            <h3 class="block-title push">{{labelOptionEnabled[actualLanguage]}}</h3>
                            <h6>{{labelOptionSeeButton[actualLanguage]}}</h6>
                        </div>
                        <div class="block-content">
                            
                            <div class="table-responsive">
                                <table class="table table-striped table-vcenter">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 50px;">{{labelEnabledColumn[actualLanguage]}}</th>
                                            <th style="width: 50%;">Option</th>
                                            <th style="width: 30%;">Detail</th>
                                        </tr>
                                    </thead>


                                    <tbody>
                                        <tr>
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.historicDataAccessDays>350" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionDataHistory1Y[actualLanguage]}}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.historicDataAccessDays>700" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionDataHistory2Y[actualLanguage]}}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.historicDataAccessDays>1000" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionDataHistory3Y[actualLanguage]}}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.historicDataAccessDays>10000" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionDataHistoryIll[actualLanguage]}}</td>
                                            <td></td>
                                        </tr>


                                        <tr>
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.dashboardEvLogFlag" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionEV_Platform[actualLanguage]}}</td>
                                            <td></td>
                                        </tr>




                                        <tr>
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.alertLimitPerBundle.max>0" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionAlert[actualLanguage]}}</td>
                                            <td>{{planOptionAlertMax[actualLanguage]}} : {{availableAlertCountString}}</td>
                                        </tr>
                                        <tr v-if="profileData.rights.rights.alertLimitPerBundle.max>0">
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.alertLimitPerBundle.max>0" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionAlertEmail[actualLanguage]}}</td>
                                            <td>{{lblThisMonth[actualLanguage]}} : {{profileData.rights.rights.emailMonthlyLimit.count}} / {{profileData.rights.rights.emailMonthlyLimit.max}}</td>
                                        </tr>

                                        <tr v-if="profileData.rights.rights.alertLimitPerBundle.max>0">
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.alertLimitPerBundle.max>0" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionAlertSMS[actualLanguage]}}</td>
                                            <td>{{lblThisMonth[actualLanguage]}} : {{profileData.rights.rights.smsMonthlyLimit.count}} / {{profileData.rights.rights.smsMonthlyLimit.max}}</td>
                                        </tr>



                                        <tr>
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.logWeatherFlag" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionWeather[actualLanguage]}}</td>
                                            <td></td>
                                        </tr>


                                        <tr>
                                            <td class="text-center">
                                                <i v-if="profileData.rights.rights.unlimitedMaterialWarranty" class="fa fa-check fa-2x text-success"></i>
                                                <i v-else  class="fa fa-times fa-2x text-danger"></i>
                                            </td>
                                            <td class="font-w600">{{planOptionUnlimitedMaterialWarranty[actualLanguage]}}</td>
                                            <td></td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <h6>*{{planOptionUnlimitedMaterialWarrantyCondition[actualLanguage]}}</h6>
                        </div>
                    </div>
                    <!-- END Full Table -->



      <!-- Pastille d'information -->
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">

            <div class="col-sm-12 col-lg-12">
                  <h2 class="block-title">{{labelCounterRenewal[actualLanguage]}}{{profileData.rights.countRenewalDate}}</h2>
                  <h2 class="block-title">{{labelSubscriptionRenewal[actualLanguage]}}{{profileData.profile_subscription.data.renewalDate}}</h2>
            </div>

        </div>
    </div>



  </div>
</template>

<script>

import _ from 'underscore'
import { mapState, mapActions } from 'vuex'

//RETRAIT STRIPE
/*
import StripePaiement from './StripePaiment'
*/


export default {
  props: ['portData'],

  components: {
    //RETRAIT STRIPE
    //StripePaiement
  },


  data() {
    return {
      
      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},
      labelTileHistoric: {FR: 'Historique de données', EN: 'Data history'},
      labelTileWeather: {FR: 'Données météo', EN: 'Weather data'},
      labelTileDataTable: {FR: 'Tableau de données', EN: 'Data table'},
      labelTileEVportal: {FR: 'Plateforme EV', EN: 'EV Portal'},
      labelTileAlert01: {FR: 'Alerte Niveau 1', EN: 'Alert Level 1'},
      labelTileAlert02: {FR: 'Alerte Niveau 2', EN: 'Alert Level 2'},
      labelTileAlert03: {FR: 'Alerte Niveau 3', EN: 'Alert Level 3'},
      labelTileAlertPerPort: {FR: 'Alerte par port', EN: 'Alert per port'},
      labelTileAlertPerModule: {FR: 'Alerte par module', EN: 'Alert per module'},
      labelTileAlertEmail: {FR: 'Alerte email', EN: 'Email alert'},
      labelMultipleRecipient: {FR: 'Multiple destinataires courriel', EN: 'Multiple email recipient'},
      labelTileAlertSMS: {FR: 'Alerte SMS', EN: 'SMS alert'},

      labelActivated: {FR: 'Activé', EN: 'Activated'},
      labelNotActivated: {FR: 'Non activé', EN: 'Not activated'},
      labelUnlimited: {FR: 'Illimité', EN: 'Unlimited'},
      labelMonth: {FR: 'Mois', EN: 'Month'},
      labelCounterRenewal: {FR: 'Date de renouvellement des compteurs :', EN: 'Counter renewal date :'},
      labelSubscriptionRenewal: {FR: 'Date de renouvellement du forfait :', EN: 'Subscription renewal date :'},



      labelOptionEnabled: {FR: 'Liste des options de votre plan de service',
                           EN: 'Option list of your actual plan'},
      labelOptionSeeButton: {FR: 'Pour voir la liste de plan disponible, utilisez le bouton MODIFIER MON PLAN DE SERVICE.',
                           EN: 'To see the list of avaible plan, use the MODIFY MY SERVICE PLAN button'},
      labelEnabledColumn: {FR: 'Active',
                           EN: 'Activated'},                          
      planOptionDataHistory1Y :{FR: "Historique de visualisation de données 1 an",
                                EN: "One year data history acess"},
      planOptionDataHistory2Y :{FR: "Historique de visualisation de données 2 an",
                                EN: "Two year data history acess"},
      planOptionDataHistory3Y :{FR: "Historique de visualisation de données 3 an",
                                EN: "Tree year data history acess"},
      planOptionDataHistoryIll :{FR: "Historique de visualisation de données illimité",
                                EN: "Unlimitted data history acess"},

      planOptionEV_Platform :{FR: "Plateforme Véhicule Électrique (EV)",
                                EN: "Electric Vehicule (VE) platform"},


      lblThisMonth : {FR: 'Mois en cours', EN: 'Actual month'},

      planOptionAlert :{FR: "Système de surveillance (configuration d'alertes)",
                                EN: "Monitoring system (alert configuration)"},
      planOptionAlertMax :{FR: "Nombre d'alerte disponible",
                                EN: "Alert count available"},
      planOptionAlertEmail :{FR: "Nombre de courriel d'alerte par mois",
                                EN: "Monthly email alert count"},
      planOptionAlertSMS :{FR: "Nombre de message texte d'alerte par mois",
                                EN: "Monthly SMS alert count"},

      planOptionWeather :{FR: "Enregistrement des données météo",
                                EN: "Weather data logging"},

      planOptionUnlimitedMaterialWarranty :{FR: "Garantie illimitée sur le matériel*",
                                EN: "Unlimited material warranty*"},

      planOptionUnlimitedMaterialWarrantyCondition :{FR: "La garantie illimité s'applique sur les deux premiers modules enregistrés au profil, pour ajouter une garantie sur les modules additionnels, vous devez contacter EV Sens.",
                                EN: "The unlimited guarantee applies to the first two modules registered in the profile, to add a guarantee to the additional modules, you must contact EV Sens."},


      numberOfDiplayedMonth : 6,
      dataTableFlag : false,
      alertL1Flag : false,
      alertL2Flag : false,
      alertL3Flag : false,
      alertL4Flag : false,

      myDashboardFlag : false,
      availableAlertCountString : '0'

    }
  },

  computed: {
    ...mapState('sessionStore', ['planTransactionData']),
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),


    cancelSelection(){
      this.displayYearToggleSelect = true
      this.displaySelectedPlanFlag = false

    },


    automaticRenewButtonSwitch(){
      if (this.automaticRenewFlagInititalValue == this.profileData.profile_subscription.data.automaticRenewFlag){
        this.renewFlagModified = true
      }
      else{
        this.renewFlagModified = false
      }
    },


  
  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.numberOfDiplayedMonth = 6
    if(this.profileData.rights.rights.historicDataAccessDays > 200){this.numberOfDiplayedMonth = 12}
    if(this.profileData.rights.rights.historicDataAccessDays > 365){this.numberOfDiplayedMonth = 20000}
    this.alertL1Flag=this.profileData.profileInfo.profile_type.endUserCode.includes('AlrtL1')
    this.alertL2Flag=this.profileData.profileInfo.profile_type.endUserCode.includes('AlrtL2')
    this.alertL3Flag=this.profileData.profileInfo.profile_type.endUserCode.includes('AlrtL3')
    this.alertL4Flag=this.profileData.profileInfo.profile_type.endUserCode.includes('AlrtL4')
    this.dataTableFlag = this.profileData.profileInfo.profile_type.endUserCode.includes('DatTbl')

    this.automaticRenewFlagInititalValue = this.profileData.profile_subscription.data.automaticRenewFlag

    if(this.profileData.rights.rights.myDashboard){this.myDashboardFlag = true}

    if(this.profileData.rights.rights.alertLimitPerBundle.max > 0){this.availableAlertCountString = this.profileData.rights.rights.alertLimitPerBundle.max}
    if(this.profileData.rights.rights.alertLimitPerBundle.max > 900){this.availableAlertCountString = this.labelUnlimited[this.actualLanguage]}


  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// MyPlanDisplay.vue?e4650fd6